import React from 'react'
import { CenteredAlignedContainer } from './Container'
import { Typography } from '@mui/material'
import { ComingSoonIcon } from '@syncfab/machine'

export default () => {
    return (
        <CenteredAlignedContainer>
            <ComingSoonIcon />
            <Typography variant="h6" component="h6" style={{ padding: 16, color: '#A7B1BB' }}>
                Coming Soon
            </Typography>
        </CenteredAlignedContainer>
    )
}
